import { Vector2, Raycaster } from "three";

const raycaster = new Raycaster();

const pointer = new Vector2();

const objects = [];
// const objects = ['flor_tile', 'house_walls', 'house_plinth', 'fence050_mesh'];

let scene;

export function initRaycaster(pScene) {
    scene = pScene;
    objects.forEach((oName, i) =>{
        (objects[i] = scene.getObjectByName(oName));
        console.log('oName: ', oName, objects[i])
    });

    container3D.addEventListener("pointermove", onPointerMove);
    container3D.addEventListener("dblclick", onClick);
}

function onPointerMove(event) {
    pointer.x = (event.clientX / container3D.offsetWidth) * 2 - 1;
    pointer.y = -(event.clientY / container3D.offsetHeight) * 2 + 1;

    const intersects = getIntersects();
    if (!intersects) return;

    servObj.onHover3D.forEach((callback) => callback(intersects));
}

function onClick() {
    const intersects = getIntersects();
    if (!intersects) return;

    servObj.onClick3D.forEach((callback) => callback(intersects));
}

function getIntersects() {
    const camera = scene.activeCamera;
    raycaster.setFromCamera(pointer, camera);
    const intersects = raycaster.intersectObjects(objects);
    return intersects.length > 0 && intersects;
}
